import { render, staticRenderFns } from "./approval-pending.vue?vue&type=template&id=53a8e64f"
import script from "./approval-pending.vue?vue&type=script&lang=js"
export * from "./approval-pending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports